import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum MilestoneReviewColumn {
    SCHEDULE = "schedule",
    SOURCE = "source",
    MILESTONE = "milestone",
    RECOGNIZED = "recognized",
    EXPECTED_DATE = "expectedDate",
    POSTING_DATE = "postingDate",
}

const makeColumnSchema = (id: MilestoneReviewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const MilestoneReviewViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.MILESTONE_REVIEW),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(MilestoneReviewColumn.SCHEDULE),
            makeColumnSchema(MilestoneReviewColumn.SOURCE),
            makeColumnSchema(MilestoneReviewColumn.MILESTONE),
            makeColumnSchema(MilestoneReviewColumn.RECOGNIZED),
            makeColumnSchema(MilestoneReviewColumn.EXPECTED_DATE),
            makeColumnSchema(MilestoneReviewColumn.POSTING_DATE),
        ]),
    ),
});

export type MilestoneReviewView = z.infer<typeof MilestoneReviewViewSchema>;
